import React, { useState, useEffect, useRef } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Form, Button, Card, Alert, Col, Row, Spinner, InputGroup} from 'react-bootstrap';
import { useProvider, Toast, isNative } from '../context/MenuProvider';
import RenderizarItem from '../components/Utils/RenderizarProduto';
import ImageCropper from '../components/Utils/ImageCropper';
import Markdown from '../components/Utils/Markdown';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import Swal from 'sweetalert2';

dayjs.locale('pt-br');

const baixarCliente = (cliente_id) => {
    const mensagem = {
      tipo: 'baixar-cliente',
      id: parseInt(cliente_id)
    };

    // ✅ FLUXO PWA
    if (navigator.serviceWorker && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage(mensagem);
    } 
    // ✅ FLUXO NATIVO (APK)
    else {
        // No nativo, enviamos para a própria window pois o service-worker.js
        // foi carregado como um script comum que ouve a window.
        window.dispatchNativeMessage(mensagem);
    }
}

const QrCodePix = ({ clienteId, hash_token, totalAberto, pagar, conInstrucoes, setResult, setCarregado, ocultarValor, perm_online}) => {
  const [valor, setValor] = useState(parseFloat(pagar || 0).toFixed(2));
  const [qrCode, setQrCode] = useState();
  const [formErrors, setFormErrors] = useState([]);

  const { crud } = useProvider();
  const navigate = useNavigate();
  const { post } = crud || {};

  useEffect(() => {
    if (parseFloat(valor || 0) > parseFloat(totalAberto || 0)) {
      setValor(parseFloat(totalAberto || 0).toFixed(2));
    } else if(parseFloat(valor || 0)<0){
      setValor(parseFloat(0).toFixed(2));
    }
  }, [valor, totalAberto]);
  
  useEffect(()=>{
    setValor(parseFloat(pagar || 0).toFixed(2));
  }, [pagar])

  useEffect(() => {
    if (!qrCode) return;

    const consultarStatusQrCodePix = async () => {
      try {
        const response = await post(
          { pagamento_id: qrCode.id },
          `/pagamento-online/integracao/${hash_token}/mercadopago/consultar-status-pagamento/`,
          null,
          "consultarStatusQrCodePix"
        );

        if (response && response.length) {
          if (response[0].pago) {
            setQrCode(null);
            setValor(parseFloat(0).toFixed(2));

            Toast.fire({
              icon: "success",
              title: "Pagamento aprovado",
            });
            
            if (typeof setResult === "function") {
              setResult(response?.[0]?.pago);
            }
            
            if(clienteId){
              baixarCliente(clienteId)
            }
          }
        }
      } catch (err) {
        alert(JSON.stringify(err.response));
      }
    };

    const interval = setInterval(consultarStatusQrCodePix, 5000);
    return () => clearInterval(interval);
  }, [qrCode]);

  const gerarQrCodePix = async (e) => {
    if (e) e.preventDefault();

    setFormErrors({});
    const errors = {};

    if (parseFloat(valor || 0) > parseFloat(totalAberto || 0)) {
      errors.valor = "O valor do pagamento não pode ser maior que o valor em aberto";
    }

    if (parseFloat(valor || 0) <= 0) {
      errors.valor = "Valor que deseja pagar deve ser maior que Zero";
    }
    if (parseFloat(hash_token || 0) <= 0) {
      errors.apiError = "Cod Cliente não informado";
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    const url = `/pagamento-online/integracao/${hash_token}/mercadopago/pagamento-valor/`;
    const dados = {
      valor: parseFloat(valor),
      modo: "qr",
    };

    try {
      const response = await post(dados, url, null, "gerarQrCodePix");
      if (response && response.length) {
        setQrCode(response[0]);
        if (typeof setCarregado === "function") {
          setCarregado("QrCodePix");
        }
      }
    } catch (err) {
      if (err.code === "ERR_NETWORK" || err.code === "ECONNABORTED" || !err.response) {
        Toast.fire({
          icon: "error",
          title: "Falha na conexão, tente novamente...",
        });
      } else {
        alert(JSON.stringify(err.response));
      }
    }
  };

  const copiarQrCodePix = () => {
    const qr = qrCode.copia_cola;

    navigator.clipboard
      .writeText(qr)
      .then(() => {
        Toast.fire({
          icon: "success",
          title: "Código QR copiado com sucesso",
        });
      })
      .catch(() => {
        Toast.fire({
          icon: "error",
          title: "Código QR não foi copiado",
        });
      });
  };
  
  
  const comoPagar = `## Como pagar?

1. Abra o app ou site do seu banco e escolha a opção de pagamento via **Pix**.  
2. Escaneie o **código QR** ou copie e cole o **código de pagamento**.  
3. Pronto! O pagamento será creditado na hora.`;

  return (
    <>
      {!qrCode && (
        <Form onSubmit={gerarQrCodePix}>
          {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
          {!ocultarValor && (<>
            <InputGroup size="lg">
                <span className="input-group-text">R$</span>
  
                <Form.Control
                  type="number"
                  placeholder="0,00"
                  value={valor || ""}
                  onChange={(e) => setValor(e.target.value)}
                  onBlur={(e) => setValor(parseFloat(e.target.value || 0).toFixed(2))}
                />
  
              <Button
                variant="outline-dark"
                type="submit"
                disabled={parseFloat(valor || 0) === 0 || !perm_online || !hash_token}
              >
                <i className="bx bx-qr"></i> Pix
              </Button>
            </InputGroup>
          </>)}
          {ocultarValor && (<>
            <Button
              variant="outline-dark"
              type="submit"
              className="w-100"
              disabled={parseFloat(valor || 0) === 0 || !hash_token}
            >
              <i className="bx bx-qr"></i> Pix
            </Button>
          </>)}
          {formErrors.valor && <Alert variant="danger">{formErrors.valor}</Alert>}
        </Form>
      )}

      {qrCode && (
        <>
          {qrCode.dados && <pre>{JSON.stringify(qrCode, null, 2)}</pre>}

          <Row>
            <Col md={4} className="px-5 px-md-0">
              <img
                src={`data:image/png;base64,${qrCode.qr_code_base64}`}
                className="img-fluid"
              />
            </Col>

            <Col md={8} className="text-center text-md-start">
              <div className="fs-3">
                Valor {parseFloat(qrCode.valor).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </div>

              <div className="fs-5">{qrCode.nome}</div>

              <div className="small text-muted">
                Expira {dayjs(qrCode.expiracao).format("dddd DD/MM/YYYY [às] HH:mm")}
              </div>

              <div className="">
                <InputGroup size="sm">
                  <span className="input-group-text">
                    <i className="bx bx-qr"></i>
                  </span>

                  <Form.Control type="text" readOnly value={qrCode.copia_cola || ""} />

                  <Button variant="outline-dark" onClick={copiarQrCodePix}>
                    <i className="bx bx-copy"></i> Copiar
                  </Button>
                </InputGroup>
              </div>

              {conInstrucoes && (
                <div className="mt-3 text-start">
                  <Markdown texto={comoPagar} />
                </div>
              )}
            </Col>
          </Row>
        </>
      )}
    </>
  );
};
const LinkPagamento = ({ clienteId, hash_token, totalAberto, pagar, conInstrucoes, setResult, setCarregado, ocultarValor, publico, perm_online}) => {
  const [valor, setValor] = useState(parseFloat(pagar || 0).toFixed(2));
  const [link, setLink] = useState();
  const [formErrors, setFormErrors] = useState([]);

  const { crud } = useProvider();
  const navigate = useNavigate();
  const { post } = crud || {};

  useEffect(() => {
    if (parseFloat(valor || 0) > parseFloat(totalAberto || 0)) {
      setValor(parseFloat(totalAberto || 0).toFixed(2));
    } else if(parseFloat(valor || 0)<0){
      setValor(parseFloat(0).toFixed(2));
    }
  }, [valor, totalAberto]);
  
  useEffect(()=>{
    setValor(parseFloat(pagar || 0).toFixed(2));
  }, [pagar])


  const gerarLinkPagamento = async (e) => {
    if (e) e.preventDefault();

    setFormErrors({});
    const errors = {};

    if (parseFloat(valor || 0) > parseFloat(totalAberto || 0)) {
      errors.valor = "O valor do pagamento não pode ser maior que o valor em aberto";
    }

    if (parseFloat(valor || 0) <= 0) {
      errors.valor = "Valor que deseja pagar deve ser maior que Zero";
    }
    if (parseFloat(hash_token || 0) <= 0) {
      errors.apiError = "Cod Cliente não informado";
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    const url = `/pagamento-online/integracao/${hash_token}/mercadopago/pagamento-valor/`;
    const dados = {
      valor: parseFloat(valor),
    };

    try {
      const response = await post(dados, url, null, "LinkPagamento");
      if (response && response.length) {
        if(publico){
          window.location.replace(response[0].pagamento_url);
        }else{
          setLink(response[0].pagamento_url);
          if (typeof setCarregado === "function") {
            setCarregado("LinkPagamento");
          }
        }
      }
    } catch (err) {
      if (err.code === "ERR_NETWORK" || err.code === "ECONNABORTED" || !err.response) {
        Toast.fire({
          icon: "error",
          title: "Falha na conexão, tente novamente...",
        });
      } else {
        //alert(JSON.stringify(err.response));
      }
    }
  };

  const copiarLink = () => {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        Toast.fire({
          icon: "success",
          title: "Link copiado com sucesso",
        });
      })
      .catch(() => {
        Toast.fire({
          icon: "error",
          title: "Código QR não foi copiado",
        });
      });
  };
  
  
  return (
    <>
      {!link && (
        <Form onSubmit={gerarLinkPagamento}>
          {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
          {!ocultarValor && (<>
            <InputGroup size="lg">
                <span className="input-group-text">R$</span>
  
                <Form.Control
                  type="number"
                  placeholder="0,00"
                  value={valor || ""}
                  onChange={(e) => setValor(e.target.value)}
                  onBlur={(e) => setValor(parseFloat(e.target.value || 0).toFixed(2))}
                />
  
              <Button
                variant="outline-dark"
                type="submit"
                disabled={parseFloat(valor || 0) === 0 || !perm_online || !hash_token}
              >
                {publico ? (<>
                  <i className="bx bx-credit-card"></i> Cartão
                </>) : (<>
                  <i className="bx bx-link"></i> Link
                </>)}
              </Button>
            </InputGroup>
          </>)}
          {ocultarValor && (<>
            <Button
              variant="outline-dark"
              type="submit"
              className="w-100"
              disabled={parseFloat(valor || 0) === 0 || !hash_token}
            >
                {publico ? (<>
                  <i className="bx bx-credit-card"></i> Cartão
                </>) : (<>
                  <i className="bx bx-link"></i> Link
                </>)}
            </Button>
          </>)}
          {formErrors.valor && <Alert variant="danger">{formErrors.valor}</Alert>}
        </Form>
      )}

      {link && (
        <>
              <div className="fs-3">
                Valor {parseFloat(valor||0).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </div>
          <InputGroup size="sm">
            <span className="input-group-text">
                <i className="bx bx-link"></i>
            </span>
            <Form.Control
                type="text"
                readOnly
                value={link || ''}
            />
            <Button variant="outline-dark" onClick={copiarLink}><i className="bx bx-copy"></i> Copiar</Button>
          </InputGroup>
        </>
      )}
    </>
  );
};
const BaixaManual = ({ clienteId, totalAberto, pagar, conInstrucoes, setResult, setCarregado, ocultarValor}) => {
  const [valor, setValor] = useState(parseFloat(pagar || 0).toFixed(2));
  const [formaPagamento, setFormaPagamento] = useState("dinheiro");
  const [taxas, setTaxas] = useState(parseFloat(0).toFixed(2));
  const [formErrors, setFormErrors] = useState([]);

  const { crud, buscarDadosPorId, salvarDados  } = useProvider();
  const navigate = useNavigate();
  const { post, put } = crud || {};


  useEffect(() => {
    if (parseFloat(valor || 0) > parseFloat(totalAberto || 0)) {
      setValor(parseFloat(totalAberto || 0).toFixed(2));
    } else if(parseFloat(valor || 0)<0){
      setValor(parseFloat(0).toFixed(2));
    }
  }, [valor, totalAberto]);
  
  useEffect(()=>{
    setValor(parseFloat(pagar || 0).toFixed(2));
  }, [pagar])
  
  useEffect(()=>{
    const vTx = parseFloat(taxas || 0);
    const vVl = parseFloat(valor || 0);
    if (vTx === 0 && vVl === 0) return;
    if (vTx > 0 && formaPagamento === "dinheiro") setTaxas(parseFloat(0).toFixed(2));
    if(vTx >= vVl){
      let vatx = parseFloat(valor)-parseFloat(0.01);
      if (vatx < 0) vatx = 0;
      setTaxas(parseFloat(vatx).toFixed(2))
    }
    else if (vTx < 0){
      setTaxas(parseFloat(0).toFixed(2))
    }
  }, [taxas, valor, formaPagamento])
  
  const baixaManual = async(e)=>{
    if (e) e.preventDefault();

    setFormErrors({});
    const errors = {};

    if (parseFloat(valor || 0) > parseFloat(totalAberto || 0)) {
      errors.valor = "O valor do pagamento não pode ser maior que o valor em aberto";
    }

    if (parseFloat(valor || 0) <= 0) {
      errors.valor = "Valor que deseja pagar deve ser maior que Zero";
    }
    if (parseFloat(clienteId || 0) <= 0) {
      errors.apiError = "Cliente não informado";
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    const vl_str = parseFloat(valor || 0).toLocaleString('pt-br', {style: 'currency',currency: 'BRL',})
    const vltx_str = parseFloat(taxas || 0).toLocaleString('pt-br', {style: 'currency',currency: 'BRL',})
    const tPgmt = formaPagamento === "cartao"?"cartão":formaPagamento;
    Swal.fire({
      title: `Baixa Manul de ${vl_str}`,
      text: `Você confirma que já recebeu o valor de ${vl_str} em ${tPgmt} ${parseFloat(taxas||0)>0?`com taxas de ${vltx_str} no recebimento`:""} e está dando baixa no sistema marcando que foi pago.`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sim, Confirmo!"
    }).then(async(result) => {
      if (result.isConfirmed) {
        try{
          const formData = new FormData();
          formData.append('valor', parseFloat(valor||0));
          formData.append('taxas', (formaPagamento === "dinheiro" ? parseFloat(0) : parseFloat(taxas||0)));
          formData.append('forma_de_pagamento', formaPagamento);
          const response = await post(formData,`/gvendas/clientes/${clienteId}/dar-baixa/`, null, "receber_valor", true, 5000);
          if(response && response.length){
            setValor(parseFloat(0).toFixed(2));
            Toast.fire({
              icon: 'success',
              title: 'Valor dado baixa com sucesso!'
            });
            baixarCliente(clienteId);
            if (typeof setResult === "function") {
              setResult(response[0]);
            }
          }
        }catch(err){
          if (err.code === 'ERR_NETWORK' || err.code === 'ECONNABORTED' || !err.response ) {
            const cliLocal = await buscarDadosPorId("db_clientes", parseInt(clienteId));
            await salvarDados('db_sync', {
              //id:`recebimento_${cliLocal?.nome_do_cliente || id_cliente}`,
              returnUrl:`/pagamentos`,
              metodo: "PUT",
              titulo: `Recebimento ${parseFloat(valor || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`,
              info: `Novo recebimento de Cliente Id: ${clienteId} no valor de ${parseFloat(valor || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} atualizado com sucesso.`,
              descricao: `
                <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr><th>Cliente Id: ${clienteId}</th></tr>
                  </thead>
                </div>
              `,
              url: `/gvendas/vendas/add_pagamento/${clienteId}/`,
              dados: {
                valor:parseFloat(valor||0),
                forma_de_pagamento:formaPagamento
              },
              tipo:"baixar-cliente",
              id:clienteId,
              data: new Date().toLocaleString("sv-SE"),
            });
            //Colocar url da fila;
            Toast.fire({
              icon: 'success',
              title: 'Valor adicionado na lista de espera de conexão!'
            });
            navigate(`/painel/sync`, { replace: true });
          } else {
            //alert(JSON.stringify(err.response))
            Swal.fire({
              title: `Erro ${err.status}`,
              text: err.response?.data?.detail ||  'Não foi possível dar baixa no pagamento',
              icon: "error"
            });
          }
        }finally{
          
        }
      }
    });
  }

  return (
    <>
        <Form onSubmit={baixaManual}>
          {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
          {!ocultarValor && (<>
            <InputGroup size="lg">
                <span className="input-group-text">R$</span>
  
                <Form.Control
                  type="number"
                  placeholder="0,00"
                  value={valor || ""}
                  onChange={(e) => setValor(e.target.value)}
                  onBlur={(e) => setValor(parseFloat(e.target.value || 0).toFixed(2))}
                />
  
              <Button
                variant="outline-dark"
                type="submit"
                disabled={parseFloat(valor || 0) === 0}
              >
                <i className="bx bx-check-double"></i> Dar Baixa Manual
              </Button>
            </InputGroup>
          </>)}
          {ocultarValor && (<>
                <div className="border-top pt-1 text-muted">
                        Já recebi o valor de {parseFloat(valor).toLocaleString('pt-br', {
                                  style: 'currency',
                                  currency: 'BRL',
                                })} e quero dar baixa manual no pagamento...
                      </div>
              <InputGroup>
                          <span className="input-group-text">{formaPagamento === "dinheiro"?"Com":"Tx"}</span>
                          {formaPagamento !== "dinheiro" && (<>
                            <Form.Control
                              readOnly={parseFloat(valor || 0) === 0}
                              type="number"
                              value={taxas || ''}
                              onChange={(e) => setTaxas(e.target.value)}
                              onBlur={(e) => setTaxas(parseFloat(e.target.value || 0).toFixed(2))}
                            />
                          </>)}
                          <Form.Select
                            disabled={parseFloat(valor || 0) === 0}
                            value={formaPagamento}
                            onChange={(e) =>setFormaPagamento(e.target.value)}
                          >
                            <option value="pix">Pix</option>
                            <option value="dinheiro">Dinheiro</option>
                            <option value="cartao">Cartão</option>
                          </Form.Select>
                          <Button
                            variant="outline-dark"
                            type="submit"
                            disabled={parseFloat(valor || 0) === 0}
                          >
                            <i className="bx bx-check-double"></i>Dar Baixa
                  </Button>
              </InputGroup>
          </>)}
          {formErrors.valor && <Alert variant="danger">{formErrors.valor}</Alert>}
        </Form>
    </>
  );
};

const OpcoesPagamento = ({ clienteId, hash_token, totalAberto, pagar, conInstrucoes, redirecionar, publico, setResult, perm_online}) => {
  const navigate = useNavigate();
  const [valor, setValor] = useState(parseFloat(pagar || 0).toFixed(2));
  const [carregado, setCarregado] = useState(false);
  const [resultado, setResultado] = useState();
  const {
    hasPerms,
  } = useProvider();
  
  useEffect(()=>{
    if (typeof setResult === "function") {
      setResult(resultado);
    }
  },[resultado])
  
  useEffect(() => {
    if (parseFloat(valor || 0) > parseFloat(totalAberto || 0)) {
      setValor(parseFloat(totalAberto || 0).toFixed(2));
    } else if(parseFloat(valor || 0)<0){
      setValor(parseFloat(0).toFixed(2));
    }
  }, [valor, totalAberto]);
  
  useEffect(()=>{
    setValor(parseFloat(pagar || 0).toFixed(2));
  }, [pagar])
  
  useEffect(() => {
    // se o pagamento mudou pra true, busca novamente após 5s
    if (!!resultado) {
      setCarregado(null);
      setValor(parseFloat(0).toFixed(2));
      const timer = setTimeout(() => {
        navigate(`${redirecionar || `/clientes/${parseInt(clienteId)}/pagamentos/`}`)
      }, 5000);
  
      return () => clearTimeout(timer); // limpa caso o componente mude antes dos 5s
    }
  }, [resultado]);
  
  return (<>
    <Row>
      {((!carregado || carregado === "BaixaManual") && ((publico && perm_online) || !publico)) && (<>
        <Col xs={6} className="mx-auto text-center">
          <i className="small">
            Em aberto {parseFloat(totalAberto || 0).toLocaleString('pt-br', {style: 'currency',currency: 'BRL',})}
          </i>
          <InputGroup size="lg">
            <span className="input-group-text">R$</span>
              <Form.Control
                  type="number"
                  placeholder="0,00"
                  value={valor || ""}
                  onChange={(e) => setValor(e.target.value)}
                  onBlur={(e) => setValor(parseFloat(e.target.value || 0).toFixed(2))}
              />
          </InputGroup>
          {(publico && perm_online) && (<div className="text-muted small text-center">
            Pagar com...
          </div>)}
        </Col>
      </>)}
      <Col xs={12} className="my-2">
          <Row>
              {((!carregado || carregado === "QrCodePix") && perm_online) && (<>
                <Col>
                  <QrCodePix clienteId={clienteId} hash_token={hash_token} totalAberto={totalAberto} pagar={valor} conInstrucoes={conInstrucoes} ocultarValor={true} setCarregado={setCarregado} setResult={setResultado} perm_online={perm_online}/>
                </Col>
              </>)}
              {((!carregado || carregado === "LinkPagamento") && perm_online) && (<>
                <Col>
                  <LinkPagamento clienteId={clienteId} hash_token={hash_token} totalAberto={totalAberto} pagar={valor} conInstrucoes={conInstrucoes} ocultarValor={true} setCarregado={setCarregado} setResult={setResultado} publico={publico} perm_online={perm_online}/>
                </Col>
              </>)}
              {!publico && (<>
                {(!carregado && hasPerms("loja.view_venda")) && (<>
                  <Col>
                    <Button variant="outline-dark" className="w-100" onClick={()=>setCarregado("BaixaManual")}>
                      <i className="bx bx-check"></i> Manual
                    </Button>
                  </Col>
                </>)}
                {carregado === "BaixaManual" && (<>
                  <BaixaManual clienteId={clienteId} totalAberto={totalAberto} pagar={valor} conInstrucoes={conInstrucoes} ocultarValor={true} setCarregado={setCarregado} setResult={setResultado}/>
                </>)}
              </>)}
          </Row>
      </Col>
    </Row>
  </>)
}

const PagamentosAberto = ({clienteId, hash_token, valorAberto, setValor, layout}) => {
  const [consulta, setConsulta] = useState();
  const { 
    crud, 
    hasPerms,
    buscarDadosPorId,
    salvarDados,
    auth,
    buscarDados,
  } = useProvider();
  const { post } = crud || {}
  
  const isConsultaCarregada = useRef(false);
  useEffect(()=>{
    if(clienteId) consultarDadosLocal();
    if(hash_token) consultarDados();
  }, [clienteId, hash_token, valorAberto])
  
  const isCarregado = useRef(false);
  useEffect(() => {
    if (isCarregado.current) return;
    isCarregado.current = consulta?.pagamentos?.length > 0;
  
    let calculo_valor = 0;
  
    for (const item of consulta?.pagamentos || []) {
      const dataPagamento = dayjs(item.data_do_pagamento).startOf('day');
      const hoje = dayjs().startOf('day');
  
      if (dataPagamento.isSame(hoje) || dataPagamento.isBefore(hoje)) {
        calculo_valor += Number(item.valor || 0);
      }
    }
  
    setValor(calculo_valor.toFixed(2));
  }, [consulta?.pagamentos]);

  const getColor = (data) => {
    const dataPagamento = dayjs(data).startOf('day');
    const hoje = dayjs().startOf('day');

    if (dataPagamento.isSame(hoje)) return 'orange';
    if (dataPagamento.isBefore(hoje)) return 'red';
    return 'inherit';
  };
  
  const consultarDadosLocal = async () => {
    try {
  
      const cliente = await buscarDadosPorId("db_clientes", parseInt(clienteId));
      if (!cliente) return;
      if (isConsultaCarregada.current) return; // já carregou via servidor
  
      setConsulta((prev) => ({
        ...prev,
        cliente: cliente.nome,
        total_aberto: cliente.total_aberto,
        data_ultima_compra: cliente.data_ultima_compra,
        data_ultimo_pagamento: cliente.data_ultimo_pagamento,
        loja: auth.empresa,
      }));
  
      const vendas = await buscarDados(
        "db_vendas",
        (x) => parseInt(x.cliente?.id) === parseInt(clienteId)
      );
      if (isConsultaCarregada.current) return; // já carregou via servidor
  
      let pagamentos = [];
  
      for (const venda of vendas) {
        const lista = await buscarDados(
          "db_pagamentos",
          (x) =>
            parseInt(x.venda?.id) === parseInt(venda?.id) && !x.pago,
          50
        );
        pagamentos = [...pagamentos, ...lista];
      }
  
      pagamentos = pagamentos.sort(
        (a, b) =>
          new Date(b.data_do_pagamento) - new Date(a.data_do_pagamento)
      );
  
      // só salva se o servidor ainda não respondeu
      if (!isConsultaCarregada.current) {
        setConsulta((prev) => ({
          ...prev,
          pagamentos,
        }));
      }
    } catch (err) {}
  };
  
  const consultarDados = async () => {
    try {
      const response = await post(
        {},
        `/pagamento-online/integracao/${hash_token}/consultar-debitos/`,
        null,
        "consultarDados",
        false
      );
  
      if (response && response.length) {
        isConsultaCarregada.current = true; // trava o carregamento local
        setConsulta(response[0]);
      }
    } catch (err) {
     // alert(JSON.stringify(err.response))
    }
  };
  
  const pagamentosAgrupadas = consulta?.pagamentos?.reduce((acc, pgmt) => {
    const data = pgmt.data_do_pagamento;
    
    if (!acc[data]) {
      acc[data] = {
        pagamentos: [],
        total: 0
      };
    }
  
    acc[data].pagamentos.push(pgmt);
    acc[data].total += parseFloat(pgmt.valor) || 0;
    
    return acc;
  }, {}) || {};
  
  return (<>
          <div className="list-group mt-1">
                  {Object.entries(pagamentosAgrupadas).length > 0 ? (
                    Object.entries(pagamentosAgrupadas).map(([data, { pagamentos, total }]) => (
                      <div key={data}>
                        <div
                          onClick={() => {
                            setValor(parseFloat(total).toFixed(2));
                          }}
                        >
                            <RenderizarItem
                              lm="mb-1"
                              col="d-none"
                              col2="col-auto text-end"
                              text1={dayjs(data).format('dddd')}
                              titulo={dayjs(data).format('DD/MM/YYYY')}
                              titulo3={parseFloat(total).toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                              bcolor={getColor(data)}
                              text3={layout === "admin"?"Receber":"Pagar"}
                            />
                          </div>
                      </div>
                    ))
                  ) : (
                      <p className="text-center mt-3 border-top pt-2 text-muted">
                        Nenhum pagamento em aberto.
                      </p>
                  )}
              </div>
  </>)
}

const Pagamento = () => {
  const { hash_token, tipo } = useParams();
  const [consulta, setConsulta] = useState();
  const [valor, setValor] = useState();
  const [result, setResult] = useState();
  const { 
    crud, 
    setTitle, 
    hasPerms,
    buscarDadosPorId,
    salvarDados,
    auth,
    buscarDados,
    navigateTo,
    catalogo,
  } = useProvider();
  const navigate = useNavigate();
  const { post, put, loading } = crud || {};
  
  setTitle("Pagamento");
  
  useEffect(() => {
    //if (clienteId && tipo){
    if (hash_token){
      consultarDados();
    }
    //if (clienteId && !tipo) gerarLinkPagamento();
  }, [hash_token, tipo]);
  
  const consultarDados = async () => {
    try {
      const response = await post(
        {},
        `/pagamento-online/integracao/${hash_token}/consultar-debitos/`,
        null,
        "consultarDados"
      );
  
      if (response && response.length) {
        const item = response[0];
        setConsulta(item);
        localStorage.setItem("hash_token", hash_token);
        if (navigator.serviceWorker && navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage("carregar-loja");
        } 
        if(isNative) window.dispatchNativeMessage("carregar-loja");
        await salvarDados("local_registros", item.loja);
      }
    } catch (err) {
      if (err.response) { // erro da resposta HTTP
        if (err.response.status === 404) {
          Toast.fire({
              icon: "error",
              title: "Cliente não encontrado",
          });
          localStorage.removeItem("hash_token");
          navigateTo(catalogo);
        } else if (err.response.status === 500) {
          
        } else {
          
        }
      } else {
        
      }
    }
  };
  
  const pagamentosAgrupadas = consulta?.pagamentos?.reduce((acc, pgmt) => {
    const data = pgmt.data_do_pagamento;
    
    if (!acc[data]) {
      acc[data] = {
        pagamentos: [],
        total: 0
      };
    }
  
    acc[data].pagamentos.push(pgmt);
    acc[data].total += parseFloat(pgmt.valor) || 0;
    
    return acc;
  }, {}) || {};
  
  const isCarregado = useRef(false);
  useEffect(() => {
    if (isCarregado.current) return;
    isCarregado.current = consulta?.pagamentos?.length > 0;
  
    let calculo_valor = 0;
  
    for (const item of consulta?.pagamentos || []) {
      const dataPagamento = dayjs(item.data_do_pagamento).startOf('day');
      const hoje = dayjs().startOf('day');
  
      if (dataPagamento.isSame(hoje) || dataPagamento.isBefore(hoje)) {
        calculo_valor += Number(item.valor || 0);
      }
    }
  
    setValor(calculo_valor.toFixed(2));
  }, [consulta?.pagamentos]);

  const getColor = (data) => {
    const dataPagamento = dayjs(data).startOf('day');
    const hoje = dayjs().startOf('day');

    if (dataPagamento.isSame(hoje)) return 'orange';
    if (dataPagamento.isBefore(hoje)) return 'red';
    return 'inherit';
  };
  
  const enviarWhatsApp = async () => {
    let whats = (consulta?.loja?.telefone_whatsapp)?.replace(/\D/g, '');
    if (whats) whats = `+55${whats}`;
    const url = `whatsapp://send?phone=${whats}`;
    window.open(url);
  };
  
  
  return (<>
    <div>
            <div>
                 <ImageCropper 
                  so_exibe={true} 
                  radius={50} 
                  foto={consulta?.loja?.logomarca} 
                  width={200} 
                  height={200} 
                />
            </div>
            <Row>
              <Col style={{ marginTop: "-10px", zIndex: 1 }}  xs="auto" className="fs-4 mb-2 bg-light text-center mx-auto">
                {consulta?.loja?.nome_da_loja||''}
                <div>
                  <Button onClick={enviarWhatsApp} variant="outline-success" size="sm" className="ms-1"><i className="bx bxl-whatsapp"></i>{` `}{consulta?.loja?.telefone_whatsapp || ``}</Button>
                </div>
              </Col>
            </Row>
    
          <Card>
            <Card.Body>
                <OpcoesPagamento 
                  hash_token={hash_token} 
                  totalAberto={parseFloat(consulta?.total_aberto || 0)} 
                  pagar={valor} 
                  conInstrucoes={true} 
                  setResult={setResult}
                  redirecionar={`/p/${hash_token}/flex/pago/`} 
                  publico={true}
                  perm_online={consulta?.pagamento_online}
                />
              
              <div className="small text-muted">
                Cliente
              </div>
              <div className="fs-3">{consulta?.cliente}</div>
  
              <p className="text-muted">
                  Total Aberto:{' '}
                  <span className="fs-4">
                    {consulta?parseFloat(consulta?.total_aberto || 0).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    }):""}
                  </span>
                  <br />
                  Última Compra:{' '}
                  {consulta?.data_ultima_compra?dayjs(consulta?.data_ultima_compra).format('DD/MM/YYYY dddd'):""}
                  <br />
                  Última Pagamento:{' '}
                  {consulta?.data_ultimo_pagamento?dayjs(consulta?.data_ultimo_pagamento).format('DD/MM/YYYY dddd'):""}
                  <br />
                  {(parseFloat(valor || 0)>0 && parseFloat(valor || 0) < parseFloat(consulta?.total_aberto || 0)) && (<code>
                      Total a ficar em aberto:
                      {parseFloat(parseFloat(consulta?.total_aberto || 0)-parseFloat(valor || 0)).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                  </code>)}
              </p>
  
              <div className="list-group mt-3">
                  {Object.entries(pagamentosAgrupadas).length > 0 ? (
                    Object.entries(pagamentosAgrupadas).map(([data, { pagamentos, total }]) => (
                      <div key={data}>
                        <div
                          onClick={() => {
                            setValor(parseFloat(total).toFixed(2));
                          }}
                        >
                            <RenderizarItem
                              lm="mb-1"
                              col="d-none"
                              col2="col-auto text-end"
                              text1={dayjs(data).format('dddd')}
                              titulo={dayjs(data).format('DD/MM/YYYY')}
                              titulo3={parseFloat(total).toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                              bcolor={getColor(data)}
                              text3={"Pagar"}
                            />
                          </div>
                      </div>
                    ))
                  ) : (
                      <p className="text-center mt-3 border-top pt-2 text-muted">
                        Nenhum pagamento em aberto.
                      </p>
                  )}
              </div>
            </Card.Body>
          </Card>
    </div>
  </>)
}

export {
  QrCodePix,
  OpcoesPagamento,
  PagamentosAberto,
}
export default Pagamento;
